// The slim landscape banner on portrait phones (Sky & Viewport): shown once per device.
const KEY = 'wits.landscapePromptDismissed';

export function landscapePromptDismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissLandscapePrompt(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // ignore
  }
}

export function resetLandscapePrompt(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
